exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".uib-datepicker .uib-title {\n  width: 100%;\n}\n\n.uib-day button, .uib-month button, .uib-year button {\n  min-width: 100%;\n}\n\n.uib-left, .uib-right {\n  width: 100%\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/angular-ui-bootstrap/src/datepicker/datepicker.css
// module id = 568
// module chunks = 1